import React, { useEffect, useState } from "react";
import { hasAddAccess } from "../../../../../Common/CheckAccess";
import AddAmenity from "./Components/AddAmenity";
import AmenityTable from "./Components/AmenityTable";

const Amenity = () => {
  const [selectedAmenity, setSelectedAmenity] = useState(null);
  const [listUpdated, setListUpdated] = useState(false);

  const [permissions, setPermissions] = useState([]);

  const existingPermissions = localStorage.getItem("checkPermission");

  useEffect(() => {
    if (existingPermissions != undefined) {
      const parsedData = JSON.parse(existingPermissions);
      setPermissions(parsedData);
    }
  }, [existingPermissions]);
  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="row g-3">
        <div className="col-sm-12">
          <div className="d-flex align-items-center justify-content-between flex-wrap">
            <h3 className="fw-bold mb-0">Amenities List</h3>
            <div className="col-auto">
              {(hasAddAccess(permissions, "rooms") ||
                hasAddAccess(permissions, "front_desk")) && (
                <button
                  type="button"
                  className="btn btn-dark"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#add-amenity"
                  aria-controls="add-amenity"
                  onClick={() => {
                    setSelectedAmenity(null);
                  }}
                >
                  Add Amenity
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="col-sm-12">
          <div className="card">
            <div className="card-body">
              <AmenityTable
                listUpdated={listUpdated}
                setSelectedAmenity={setSelectedAmenity}
                permissions={permissions}
              />
            </div>
          </div>
        </div>
      </div>
      <AddAmenity
        selectedAmenity={selectedAmenity}
        setSelectedAmenity={setSelectedAmenity}
        setListUpdated={setListUpdated}
      />
    </div>
  );
};

export default Amenity;
